import { render, staticRenderFns } from "./StatBar.vue?vue&type=template&id=47a5e47c&lang=pug&"
import script from "./StatBar.vue?vue&type=script&lang=js&"
export * from "./StatBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports